import React from 'react';
import { Header } from '../components/site/Header';
import { Footer } from '../components/site/Footer';
import { Hero } from '../components/sections/Hero';
import { Services } from '../components/sections/Services';
import { About } from '../components/sections/About';
import { ContactSection } from '../components/sections/ContactSection';
export function PublicSite() {
  return <div className="flex min-h-screen w-full flex-col bg-canvas" data-id="element-639" data-mp="j9s3hsymt4qa">
      <Header data-id="element-640" data-mp="j908aj8y590j" />
      <main className="flex-1" data-id="element-641" data-mp="jbmfghrxdmi8">
        <Hero data-id="element-642" data-mp="f7ok8i5q0vug" />
        <Services data-id="element-643" data-mp="f99e05k7oar9" />
        <About data-id="element-644" data-mp="f8q4nd8mmuou" />
        <ContactSection data-id="element-645" data-mp="faayt1r14bm6" />
      </main>
      <Footer data-id="element-646" data-mp="agybcuy36av0" />
    </div>;
}